import { t } from 'i18n';

/**
 * 根据 ResultCode 编码获取国际化翻译。
 *
 * 编码格式：{MODULE}_{ERROR_NAME}，如 "TMS_TASK_NOT_FOUND"
 * i18n key 格式：resultCode.{MODULE}.{ERROR_NAME}，如 "resultCode.TMS.TASK_NOT_FOUND"
 *
 * @param code ResultCode 编码
 * @param fallback 翻译未命中时的兜底文案
 * @param params i18n 插值参数（后端 Result.argsJson 解析而来，如 { sortingCode: 'HOU' }）
 * @returns 翻译后的文案
 */
export function parseResultCode(code: string, fallback?: string, params?: Record<string, unknown>): string {
    if (!code || code === '0') return '';
    const idx = code.indexOf('_');
    const module = idx > 0 ? code.substring(0, idx) : code;
    const detail = idx > 0 ? code.substring(idx + 1) : code;
    const key = `resultCode.${module}.${detail}`;
    const translated = t(key, params ?? undefined);
    return translated !== key ? translated : (fallback || code);
}

/** 解析后端 Result.argsJson 为 i18n 插值参数对象；非法/空则返回 undefined */
export function parseResultArgs(argsJson?: string | null): Record<string, unknown> | undefined {
    if (!argsJson) return undefined;
    try {
        const obj = JSON.parse(argsJson);
        return obj && typeof obj === 'object' ? obj : undefined;
    } catch {
        return undefined;
    }
}

/**
 * 后端 Result 失败时的提示文案：按 code 翻译（argsJson 作为插值参数），翻译未命中回退后端 message，
 * 都没有（如未拿到 Result）时回退 fallback。
 */
export function resultErrorMessage(
    res: { code?: string | null; message?: string | null; argsJson?: string | null } | null | undefined,
    fallback: string,
): string {
    return parseResultCode(res?.code ?? '', res?.message ?? undefined, parseResultArgs(res?.argsJson)) || fallback;
}
